import React from 'react';
import Container from '../container';
import styled, { css } from 'styled-components';
import mq from '../../utils/mq';
import RichtextParser from '../../utils/richtext-parser';
import LogoGridItem from './LogoGridItem';
import Button from '../button';
import parseStoryblokLink from '../../utils/parseStoryblokLink';

const OuterContainer = styled.div<{ $theme?: 'white' | 'grey' }>`
  background-color: ${({ $theme }) =>
    $theme === 'white' ? '#fff' : '#f8f8f8'};
  padding-top: 94px;
  padding-bottom: 94px;
  ${mq.mobile(css`
    padding-top: 64px;
    padding-bottom: 64px;
  `)};
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  text-align: center;
  padding-bottom: 65px;
  max-width: 720px;
  margin: 0 auto;
  ${mq.mobile(css`
    padding-bottom: 32px;
    max-width: unset;
    text-align: left;
    align-items: flex-start;
    gap: 16px;
  `)};
`;

const Title = styled.h2`
  color: #161616;
  font-size: 42px;
  font-style: normal;
  font-weight: 700;
  line-height: 115%;
  letter-spacing: -0.84px;
  text-align: inherit;
  ${mq.mobile(css`
    font-size: 36px;
  `)};
`;

const Description = styled.div`
  color: #666;
  text-wrap: pretty;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.36px;
  text-align: inherit;
`;

const GridItems = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;

  ${mq.mobile(css`
    gap: 16px;
  `)};
`;

const CtaContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 64px;
  ${mq.mobile(css`
    margin-top: 32px;
  `)};
`;

export default function LogoGridSection({
  title,
  description,
  gridItems,
  ctaLink,
  ctaLabel,
  theme = 'white'
}: {
  title: string;
  description: any;
  gridItems: any[];
  ctaLink: any;
  ctaLabel: string;
  theme?: 'white' | 'grey';
}) {
  return (
    <OuterContainer $theme={theme}>
      <Container>
        <TitleSection>
          <Title>{title}</Title>
          <Description
            dangerouslySetInnerHTML={{ __html: RichtextParser(description) }}
          />
        </TitleSection>
        <GridItems>
          {gridItems.map((item, i) => (
            <LogoGridItem key={i} {...item} theme={theme} />
          ))}
        </GridItems>
        {ctaLink && ctaLabel && (
          <CtaContainer>
            <Button to={parseStoryblokLink(ctaLink)}>{ctaLabel}</Button>
          </CtaContainer>
        )}
      </Container>
    </OuterContainer>
  );
}
